import { Xeg } from './xeg';
import { Yot } from './yot';
import { Zim } from './zim';

export const STAR_LIST = [Zim, Yot, Xeg];

['springgreen', 'yellow', 'orangered'].forEach((color, i) => STAR_LIST[i].color = color);